import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { Footer, Blog, Possibility, Features, WhatGPT3, Header } from './containers';
import { CTA, Brand, Navbar, Products, ProductDetail, Services } from './components';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import AboutUs from './pages/AboutUs';
import FileService from './pages/FileService';
import ServiceDetail from './pages/ServiceDetail';
import SupportList from './pages/SupportList';
import './App.css';

const HomeContent = () => (
    <>
        <div className='gradient__bg'>
            <Header />
        </div>
        <Brand />
        <Products />
        <Services />
        <WhatGPT3 />
        <Features />
        <Possibility />
        <CTA />
        <Blog />
        <Footer />
    </>
);

const app = () => {
    return (
        <Router>
            <div className='App'>
                <div className='gradient__bg'>
                    <Navbar />
                </div>
                <Routes>
                    <Route path="/" element={<HomeContent />} />
                    <Route path="/product/:productId" element={<ProductDetail />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/file-service" element={<FileService />} />
                    <Route path="/file-service/:id" element={<ServiceDetail />} />
                    <Route path="/support-list" element={<SupportList />} />
                </Routes>
            </div>
        </Router>
    );
}

export default app;
